module.exports = __webpack_public_path__ + "img/blog-3.592b0bfd.jpeg";